import { render, staticRenderFns } from "./birthdayRemind.vue?vue&type=template&id=2bdac006&scoped=true&"
import script from "./birthdayRemind.vue?vue&type=script&lang=js&"
export * from "./birthdayRemind.vue?vue&type=script&lang=js&"
import style0 from "./birthdayRemind.vue?vue&type=style&index=0&id=2bdac006&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdac006",
  null
  
)

export default component.exports